<template>
    <v-container fluid class="secondary">
      <v-card elevation="11" class="primary pa-2" >
        <v-row class="justify-center align-center"><h1 class="font-weight-black textTitle--text">{{ $t('managefournisseur.supplierScreenTtile') }}</h1></v-row>
        
        <v-row class="justify-center align-center">
          <v-col cols="4">
            <v-card elevation="11" class="ma-3 pa-3 secondary">
            <v-list dense v-if="fournDb.length" class="tertiary">
              <v-row class="justify-center">
              <h2 class="font-weight-black black--text">{{ $t('managefournisseur.suppliers') }}</h2>
              </v-row>
              <v-list-item-group
                v-model="fournisseur"
                color="primary"
                
              >
                <v-list-item
                  v-for="(fourn, i) in fournDb"
                  :key="i"
                  @click="fournActif=fourn"
                >
                  
                  <v-list-item-content>
                    <v-row class="justify-center align-center">
                      <h3 class="mr-3">{{fourn.name}}</h3>
                      <v-btn elevation="11" x-small class="ma-3 pa-3 error font-weight-black black--text" @click="deleteFourn(fourn)">{{ $t('delete') }}</v-btn>
                    </v-row>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
            </v-card>
            
          </v-col>
          <v-col cols="8">
            <v-row class="justify-center align-center">
              <h2 class="font-weight-bold textTitle--text ma-5 pa-4">{{$t('managefournisseur.supplierName')}} </h2>
              <v-text-field solo outlined v-model="fournName" class="ma-5 pa-3 font-weight-black shrink" background-color="quinty"></v-text-field>
             </v-row>
            <v-row class="justify-center align-center">
              <v-btn class="ma-3 pa-3 success font-weight-black black--text" elevation="11" @click="addFournisseur">{{ $t('managefournisseur.supplierCreateButton') }}</v-btn>
        </v-row>
          </v-col>
        </v-row>
        <v-card>
          
        </v-card>
        
        
      </v-card>
  
</v-container>
</template>

<script>
import {mapGetters} from 'vuex'

  export default {
      props:['product'],
    data () {
      return {
        fournisseur:'',
        fournName:'',
        fournActif:{}
      }
    },
    computed:{
      ...mapGetters({
        fournDb:'fournDb',
      })
    },
    methods: {
        deleteFourn(fourn){
          
          var pos = this.$store.state.fournDb.map(function(e) { return e.id; }).indexOf(fourn.id)
                  this.$store.state.fournDb.splice(pos, 1); 
              
          
          
           
        },
        addFournisseur(){
          
            var id = 'fourn1';
            var fournDb = this.$store.state.fournDb;
            var pos = 0
        // ajoute l'item en verifiant l'id. si l'id existe, continue d'essayer jusqu'a trouver un id valide, 
        // permet de remplir les vides laisser par les suppressions precedentes
        if(fournDb.length>0){
               
            var size = fournDb.length+1
            pos=1

            for(var i=0;i<size-1;i++){
              if(fournDb[i].id!=id){continue}else{
                pos+=1
                id='fourn'+pos
                id=0
              }
            }
            }
        // inscrit l'item dans la bdd et recharge
                this.$store.state.fournDb.push({id:id,name:this.fournName})
        
        }
    },
  }
</script>